import { render, staticRenderFns } from "./ViewerToolbarDesign.vue?vue&type=template&id=0c2734d0&scoped=true"
import script from "./ViewerToolbarDesign.vue?vue&type=script&lang=js"
export * from "./ViewerToolbarDesign.vue?vue&type=script&lang=js"
import style0 from "./ViewerToolbarDesign.vue?vue&type=style&index=0&id=0c2734d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2734d0",
  null
  
)

export default component.exports